"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _TopAreaBanner = require("../TopAreaBanner");
const TOP_AREA_BORDER_BOTTOM = 1;
const Root = exports.Root = (0, _mui.styled)('header', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  isSearchInputVisible,
  isTopBannerVisible
}) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.common.white,
  borderBottom: `${TOP_AREA_BORDER_BOTTOM}px solid ${isSearchInputVisible ? theme.palette.common.white : theme.palette.grey[200]}`,
  boxSizing: 'border-box',
  display: 'flex',
  height: _presentationUtils.CSS_MOBILE_INNER_HEIGHT,
  left: 0,
  padding: theme.spacing(0, 3),
  position: 'fixed',
  top: isTopBannerVisible ? _TopAreaBanner.TOP_AREA_BANNER_HEIGHT : 0,
  transition: `height ${_presentationUtils.CSS_HEIGHT_ANIMATION}, background-color 0.1s ease-in-out`,
  width: '100%',
  zIndex: theme.zIndex.appBar,
  [theme.breakpoints.up('md')]: {
    borderBottom: `${TOP_AREA_BORDER_BOTTOM}px solid ${theme.palette.grey[200]}`,
    height: _presentationUtils.CSS_DESKTOP_INNER_HEIGHT,
    padding: theme.spacing(0, 6)
  }
}));